import PropTypes from 'prop-types';
import Female from 'assets/img/product/gender/female.png';
import Male from 'assets/img/product/gender/male.png';
import FemaleLight from 'assets/img/product/gender/female-blue.png';
import MaleLight from 'assets/img/product/gender/male-blue.png';
import { Label } from 'components/Typography';
import { Container, Select } from './styled';

const GenderInput = ({ formik, size, label, name, variant }) => {
  const value = formik.values[name];

  const onChange = (gender) => {
    formik.setFieldValue(name, gender);
    formik.setFieldTouched(name, true, true);
  };

  return (
    <>
      <Label size={size} variant={variant}>
        {label}
      </Label>
      <Container size={size}>
        <Select
          variant={variant}
          isSelected={value === 'female'}
          onClick={() => onChange('female')}
        >
          <img src={variant === 'dark' ? FemaleLight : Female} alt="Female" />
          <p>Female</p>
        </Select>
        <Select
          variant={variant}
          isSelected={value === 'male'}
          onClick={() => onChange('male')}
        >
          <img src={variant === 'dark' ? MaleLight : Male} alt="Male" />
          <p>Male</p>
        </Select>
      </Container>
    </>
  );
};

GenderInput.propTypes = {
  formik: PropTypes.object,
  name: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.string,
  variant: PropTypes.oneOf(['light', 'dark'])
};

GenderInput.defaultProps = {
  size: 'medium',
  variant: 'dark'
};

export default GenderInput;
